// extracted by mini-css-extract-plugin
export default {"rank_diff_of_creator_summary":"rank_diff_of_creator_summary__7751771a"};